<!-- @Version: 1.0.1 --> 
@if (done$$()  == true) {
  <form [formGroup]="fgAllFunction">
    <div >
      <div class="slide-toogle">
        <mat-label ngClass="labelBeforeSlide">{{fieldItem.attribute_1}}</mat-label>
        <mat-slide-toggle data-testid="slide-toggle" class="example-margin" [color]="TRANSLATE_PATH.COLOR_BUTTON_COMMON | translateDesign"   [formControlName]="FC_ALL_TOGGLE.ALLTOGGLEFUNCTION">
          {{fieldItem.attribute_2}}
        </mat-slide-toggle>
      </div>
    </div>
  </form>
}
